export const debounceDelay = 500;
export const creditsFeatureKey = "beta::credits";
